import { render, staticRenderFns } from "./ListDamage.vue?vue&type=template&id=428dddad&"
import script from "./ListDamage.vue?vue&type=script&lang=js&"
export * from "./ListDamage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports